import { SectionContainer } from "@/components/Sections";
import {
  CompetenceWithCardProps,
  TopicCardContainer,
} from "@/components/MotivationScan/TopicCardContainer";
import React, { useState } from "react";
import { CompetenceBaseEx } from "@/server/backend-api";
import { MotivationScanAnswers } from "@/utils/motivationScan";

interface Props {
  competences: CompetenceBaseEx[];
  answers: MotivationScanAnswers;
  onNextClicked: () => void;
  onCardLikeClicked: (c: CompetenceBaseEx) => void;
  onCardDislikeClicked: (c: CompetenceBaseEx) => void;
}

export function MotivationScanFirstStep(props: Props) {
  const { competences, answers } = props;
  const competencesWithProps = competences.map((c) => {
    const withProps: CompetenceWithCardProps = {
      competence: c,
      cardProps: {
        likeOrDislike: answers[c.id]?.likeOrDislike,
      },
    };
    return withProps;
  });
  const hasLikedCompetences = competences.some(
    (c) => answers[c.id]?.likeOrDislike === "like"
  );
  const [currentCardIndex, setCurrentCardIndex] = useState(0);

  return (
    <>
      <SectionContainer defaultPadding={false}>
        <div className="flex flex-col justify-center items-center text-style-body2 tablet-sm:text-style-headline4 mb-lg laptop:mb-2xl">
          <span className="text-style-caption">
            Topic {Math.min(currentCardIndex + 1, competences.length)} of{" "}
            {competences.length}
          </span>
          <h1 className="text-style-headline5 tablet:text-style-headline3 mt-sm tablet:mt-xl">
            Which topic interests you more?
          </h1>
          <span className="mt-sm max-w-[500px] text-center text-style-body2 tablet:text-style-body1">
            Hit &#39;Like&#39; for the options you feel suit best your interests
            and needs to help us provide you with unique suggestions.
          </span>
        </div>
      </SectionContainer>
      <TopicCardContainer
        competences={competencesWithProps}
        onCurrentClosestCardIndexChanged={(newClosestCardIndex) => {
          setCurrentCardIndex(newClosestCardIndex);
        }}
        onCardDislikeClicked={props.onCardDislikeClicked}
        onCardLikeClicked={props.onCardLikeClicked}
        callToActionCard={{
          text: "Let's get more specific in the next step",
          buttonLabel: "Next step",
          onClick: props.onNextClicked,
          disabled: !hasLikedCompetences,
        }}
      />
    </>
  );
}
